<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Items</h5>
                    <div class="table-responsive">
                        <table class="table center-aligned-table">
                            <thead>
                                <tr>
                                    <th class="border-bottom-0">No.</th>
                                    <th class="border-bottom-0">Name</th>
                                    <th class="border-bottom-0">Price</th>
                                    <th class="border-bottom-0">Category</th>
                                    <th class="border-bottom-0">
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(i, index) in itemsFromRepository">
                                    <td> {{ index + 1 }} </td>
                                    <td> {{ i.itemName }} </td>
                                    <td> {{ i.originalPrice }} </td>
                                    <td> {{ i.category }} </td>
                                    <td>
                                        <b-form-checkbox v-on:input="handleItemCheckedBox($event, i)"
                                                         v-model="i.isChecked">
                                        </b-form-checkbox>  
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import { mapActions, mapState, mapGetters } from'vuex'
import MenuStepBase from '../Bases/MenuStepBase'
export default{
    name: 'menuadditemslist',
    extends : MenuStepBase,
    inject: ['eventBus'],
    props : {
        menu : { type: Object }
    },
    data () {
        return {
            selectedItems:  [],
            value: [],
            options: [],
      }
    },
    computed: {
        ...mapState({
          itemsFromRepository: state => state.menuitems.itemsFromRepository,
      })
    },
    methods: {
        handleItemCheckedBox(event, item) {
            if (event === true) {
                this.selectedItems.push(item.itemId);
            }
            else {
                let index = this.selectedItems.findIndex(i => {
                    return i === item.itemId
                });
                if (index > -1) {
                    this.selectedItems.splice(index, 1);
                }
             }
        },
        handleOnNextEvent() {
            this.menu.menuItems = this.selectedItems;
        },
        handleOnBackEvent() {

        }
    },
    async created() {
        await this.$store.dispatch('restaurants/getRestaurantsAction');
        await this.$store.dispatch('menuitems/getCategoriesFromRepositoryAction');
        await this.$store.dispatch('menuitems/getItemsFromRepositoryAction');
    }
}
</script>

<style lang="scss">
   
</style>